import React, { useEffect, useState } from 'react';
import { Table, Spin, message, Button } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import { config } from '../utils';
import { useNavigate } from 'react-router-dom';
import {  EnvironmentOutlined } from '@ant-design/icons';

interface Constituency {
    id: string;
    constituency: string;
    region: string;
}

const ConstituenciesList = () => {
    const [constituencies, setConstituencies] = useState<Constituency[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchConstituencies();
    }, []);

    const fetchConstituencies = async () => {
        setLoading(true);

        // Check if constituencies are stored in session storage
        const storedConstituencies = sessionStorage.getItem('constituencies');
        if (storedConstituencies) {
            setConstituencies(JSON.parse(storedConstituencies));
            setLoading(false);
            return;
        }

        try {
            const response = await axiosInstance.get(config.api.endpoints.constituencies);
            setConstituencies(response.data);

            // Store constituencies in session storage
            sessionStorage.setItem('constituencies', JSON.stringify(response.data));
        } catch (error) {
            message.error('Failed to fetch constituencies');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'Constituency',
            dataIndex: 'constituency',
            key: 'constituency',
            sorter: (a: Constituency, b: Constituency) => a.constituency.localeCompare(b.constituency),
        },
        {
            title: 'Region',
            dataIndex: 'region',
            key: 'region',
            sorter: (a: Constituency, b: Constituency) => a.region.localeCompare(b.region),
        },
    ];

    if (loading) {
        return (
            <div className="flex justify-center items-center h-full">
                <Spin tip="Loading constituencies..." />
            </div>
        );
    }

    return (
        <div className="p-8">
            <div className="flex justify-between items-center mb-6">
            <div className="flex items-center p-5 gap-2">
            <EnvironmentOutlined className="text-2xl text-red-600" />
               <p className="text-md text-black font-bold">Constituencies</p>
            </div> 
            <Button onClick={() => navigate('/settings')} >
                Back 
            </Button> 
            </div> 
            <Table
                dataSource={constituencies}
                columns={columns}
                rowKey="id"
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

export default ConstituenciesList;